function matchesLocationByPath(windowObj, path) {
  var locationPath = windowObj.location.pathname;
  return !!locationPath.match(path);
}
export function isDuringQuizTake() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return matchesLocationByPath(windowObj, /taking\/\d+\/take/);
}
export function isDuringQuizBuild() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return matchesLocationByPath(windowObj, /build\/\d+$/);
}